import { post } from '@/helper/request';

const trackDownload = async (downloadLocation: string) => {
  await post('/external/unsplash/trackDownload', { downloadLocation }).then((res) => {
    if (res?.success === false) {
      throw new Error(res.message);
    }
    return res;
  });
};

export default trackDownload;
